import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';

import client from '@/apis/aniftyBackend/client';
import { DraftToken, UserPageFilterCondition } from './interface';

export type GetUserDraftCreationsResponse = {
  nextPage: number | undefined;
  draftCreations: DraftToken[];
};

export const getUserDraftCreations = async ({
  userID,
  page,
  filterCondition,
}: {
  userID: string;
  page: number;
  filterCondition: UserPageFilterCondition;
}): Promise<GetUserDraftCreationsResponse> => {
  const response = await client.get<GetUserDraftCreationsResponse>(
    `/api/users/${userID}/draft_creations`,
    {
      params: {
        page,
        availability: filterCondition.availability,
        sort: filterCondition.sort,
      },
    }
  );
  return response.data;
};

export const useFetchUserDraftCreations = ({
  userID,
  filterCondition,
}: {
  userID: string;
  filterCondition: UserPageFilterCondition;
}): UseInfiniteQueryResult<GetUserDraftCreationsResponse> => {
  return useInfiniteQuery({
    queryKey: ['/user/draft_creations', userID, filterCondition],
    queryFn: ({ pageParam = 0 }) => {
      return getUserDraftCreations({
        userID,
        page: pageParam,
        filterCondition,
      });
    },
    getNextPageParam: (prevData) => {
      return prevData.nextPage;
    },
  });
};
